import React, { useContext } from "react";
import Pagination from "react-js-pagination";
import UpgradeModal from "../../UpgradeModal/UpgradeModal";
import Modal from "../../Shared/PopupModal/PopupModal";
import BulkAssignLorriAgentModal from "./AssignLorriAgent/BulkAssignLorriAgentModal";
import { SHINE_ANIMATION_DELAY } from "./AssignLorriAgent/shineSync";
import { isMobile, Activity, currentRequestTimeStamp } from "../../../Constants";
import { toast } from "react-toastify";
import classes from "../TrucksAvailable.module.css";
import { UserApiContext } from "../../UserDetailsContext/UserDetailsContext";

const EnquirySubmitFooter = ({
  send_data,
  validateUser,
  backbutton,
  discovernowbutton,
  planningbutton,
  skipactive,
  visible_enquiry,
  totalcount,
  getOnChange,
  closeButtonModal1,
  submitHandler,
  setsend_data,
  spotNoAccess,
  isRestricted,
  showStatusColumn,
  requestapprovallist,
  setRequestapprovallist,
  company_id,
  fetchSpotData,
  currentFilterPayload,
  defaultRounds,
}) => {
  const { userDetails } = useContext(UserApiContext)

  const showBulkAssignCta =
    !backbutton &&
    !discovernowbutton &&
    !planningbutton &&
    send_data.length === 0 &&
    showStatusColumn;

  const showPagination =
    !backbutton &&
    !discovernowbutton &&
    !planningbutton &&
    send_data.length === 0 &&
    totalcount > visible_enquiry;

  const bulkAssignCta = (
    <Modal
      buttonLabel={
        <>
          <i className="fa fa-magic pr-2" />
          Assign LoRRI Agent
        </>
      }
      buttonClass={`btn btn-sm ${classes["lorri-agent-bulk-button"]}`}
      style={{
        "--shine-delay": SHINE_ANIMATION_DELAY,
        cursor: isRestricted ? "not-allowed" : "pointer",
        opacity: isRestricted ? 0.6 : 1,
      }}
      disabled={requestapprovallist.length === 0 || isRestricted}
      content={({ onClose }) => (
        <BulkAssignLorriAgentModal
          items={requestapprovallist}
          onClose={() => {
            setRequestapprovallist([]);
            onClose();
          }}
          company_id={company_id}
          fetchSpotData={fetchSpotData}
          currentFilterPayload={currentFilterPayload}
          defaultRounds={defaultRounds}
        />
      )}
      title={`Assign LoRRI Agent — confirm target rate`}
      id="closebutton-bulk-lorri-agent"
      size="lg"
      screenName="LoRRI Spot"
      moduleName="My Enquiries"
      activityName={`Bulk Assign LoRRI Agent clicked for ${requestapprovallist.length} lanes`}
      backdrop={false}
    />
  );

  const paginationControl = (
    <div className={classes["lorri-pagination"]}>
      <Pagination
        activePage={skipactive === 0 ? 1 : skipactive}
        itemsCountPerPage={visible_enquiry}
        totalItemsCount={totalcount}
        onChange={(e) => getOnChange(e)}
        itemClass="page-item"
        linkClass="page-link"
        hideDisabled
      />
    </div>
  );

  return (
    <>
      {!isMobile() ? (
        <div className="w-100">
          <center
            className={`${discovernowbutton && planningbutton ? "s-enquiry" : ""} `}
            style={{ marginTop: "1%" }}
          >
            <center style={{ display: "contents" }}>
              {backbutton || discovernowbutton || planningbutton ? (
                <button
                  className="btn btn-sm btn-primary mr-5"
                  onClick={() => closeButtonModal1()}
                >
                  Back
                </button>
              ) : null}
            </center>
            {send_data.length > 0 && (
              <>
                {validateUser === "basic" ? (
                  <UpgradeModal
                    screenName="LoRRI Spot"
                    moduleName="Upgrade Popup"
                    activityName="Submit button clicked"
                    buttonClass="btn btn-sm btn-success"
                    buttonLabel="Submit"
                    feature="Submit Enquiry"
                  />
                ) : backbutton || discovernowbutton || planningbutton ? (
                  <button
                    style={{ marginLeft: "2%" }}
                    onClick={(e) => {
                      e.target.disabled = true;
                      submitHandler(e);
                    }}
                    className="btn btn-sm btn-success"
                    disabled={spotNoAccess || isRestricted}
                  >
                    Submit
                  </button>
                ) : (
                  <>
                    <button
                      onClick={(e) => {
                        e.target.disabled = true;
                        submitHandler(e);
                      }}
                      className={`btn btn-sm btn-success`}
                      disabled={spotNoAccess || isRestricted}
                    >
                      Submit
                    </button>
                    <button
                      className={`btn btn-sm btn-primary`}
                      style={{ margin: "0 1%" }}
                      onClick={(e) => {
                        Activity({
                          screen: "LoRRI Spot",
                          module: "LoRRI Spot",
                          user_activity: "Cancelled all enquiries",
                          timestamp: currentRequestTimeStamp(),
                          "userEmail": userDetails?.email, "userName": userDetails?.user_name, "companyname": userDetails.company_name
                            ? userDetails.company_name
                            : userDetails.email
                              ? userDetails.email.split("@")[1].split(".")[0]
                              : ""
                        });
                        toast.success("Cancelled all enquiries");
                        setsend_data([]);
                      }}
                    >
                      Cancel
                    </button>
                  </>
                )}
              </>
            )}
          </center>
          {(showBulkAssignCta || showPagination) && (
            <div className={classes["lorri-agent-cta-row"]}>
              <div />
              <div className={classes["lorri-agent-cta-center"]}>
                {showBulkAssignCta && bulkAssignCta}
              </div>
              <div className={classes["lorri-agent-cta-pagination"]}>
                {showPagination && paginationControl}
              </div>
            </div>
          )}
        </div>
      ) : (
        <>
          <div style={{ display: "flex", marginTop: "2%", marginLeft: "5%" }}>
            <center style={{ display: "contents" }}>
              {(backbutton || discovernowbutton || planningbutton) && (
                <button
                  className="btn btn-sm btn-primary"
                  style={{
                    marginRight: "10%",
                    marginLeft: "35%",
                    marginBottom: isMobile() ? "2%" : "",
                  }}
                  onClick={() => closeButtonModal1()}
                >
                  Back
                </button>
              )}
            </center>
          </div>
          <center>
            {send_data.length > 0 && (
              <>
                {validateUser === "basic" ? (
                  <UpgradeModal
                    screenName="LoRRI Spot"
                    moduleName="Upgrade Popup"
                    activityName="Submit button clicked"
                    buttonClass="btn btn-sm btn-success"
                    buttonLabel="Submit"
                    feature="Submit Enquiry"
                  />
                ) : backbutton || discovernowbutton || planningbutton ? (
                  <button
                    onClick={(e) => {
                      e.target.disabled = true;
                      submitHandler(e);
                    }}
                    className="btn btn-sm btn-success"
                    disabled={spotNoAccess || isRestricted}
                  >
                    Submit
                  </button>
                ) : (
                  <button
                    onClick={(e) => {
                      e.target.disabled = true;
                      submitHandler(e);
                    }}
                    style={{ marginLeft: "4%" }}
                    className={`btn btn-sm btn-success ${classes["s-sub"]} `}
                    disabled={spotNoAccess || isRestricted}
                  >
                    Submit
                  </button>
                )}
              </>
            )}
          </center>
          {(showBulkAssignCta || showPagination) && (
            <div className={classes["lorri-agent-cta-row"]}>
              {showBulkAssignCta && (
                <div className={classes["lorri-agent-cta-center"]}>
                  {bulkAssignCta}
                </div>
              )}
              {showPagination && (
                <div className={classes["lorri-agent-cta-pagination"]}>
                  {paginationControl}
                </div>
              )}
            </div>
          )}
        </>
      )}
    </>
  );
};

export default EnquirySubmitFooter;
